/* CITRIN BUNDLE TEST B v3 - "Shop all styles" tab for the Complete-the-set sheet (Oct 2026).
   Adds two tabs to the sheet: "Best matches" (the existing 6 suggestions) and "Shop all styles".
   The second tab loads every in-stock product in the WELCOME-15 collection (the Bundle & Save
   range) on first open, grouped one row per style with colour pills, size chips, search and
   type filters. Accessories (socks, caps) are left out. Picks go back to the picker through
   sheet.__cbpPick(p, v). Listens for the picker's "cbp:sheet-open" event. */
(function(){
if (window.__citrinBrowse) return; window.__citrinBrowse = true;
var PREFIX = /^(DAILY BASIS|TRUE SHAPE|SHAPE EDIT|OFF DUTY|NOT SO BASIC|SWEAT SERIES)\s+/;
var FILTERS = [['all','All'],['tops','Tops'],['bottoms','Bottoms'],['layers','Layers'],['onepiece','One-pieces']];
var cache = null, loading = null;
function fmt(c){ var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'AUD'; try{ return new Intl.NumberFormat('en-AU',{style:'currency',currency:cur}).format(c/100); }catch(e){ return '$'+(c/100).toFixed(2); } }
function bundle(c){ return Math.round(c*0.85); }
function el(t,c,x){ var n=document.createElement(t); if(c) n.className=c; if(x!=null) n.textContent=x; return n; }
function cat(x){
  var s=(x.title+' '+(x.product_type||'')).toUpperCase();
  if(/DRESS|ONE PIECE|BODYSUIT/.test(s)) return 'onepiece';
  if(/JACKET|BOLERO|LAYERING TOP|QUARTER ZIP/.test(s)) return 'layers';
  if(/LEGGING|SHORT|CAPRI|PANT|BOTTOMS/.test(s)) return 'bottoms';
  if(/CROP|TANK|CAMI|T-SHIRT|TOP/.test(s)) return 'tops';
  return 'other';
}
function toP(x){
  var t=x.title.split(' - '), full=t[0].toUpperCase().trim(), m=full.match(PREFIX), si=0;
  (x.options||[]).forEach(function(o,i){ if(/size/i.test(o.name)) si=i; });
  var img=x.images&&x.images[0]?x.images[0].src:''; if(img) img+=(img.indexOf('?')>-1?'&':'?')+'width=300';
  var vs=x.variants.map(function(v){ return {id:v.id,size:v['option'+(si+1)],price:Math.round(parseFloat(v.price)*100),available:!!v.available}; });
  return {id:x.id,name:full.replace(PREFIX,'').trim()||full,range:m?m[1]:'',colour:t.length>1?t[t.length-1].trim():'',image:img,
    price:Math.min.apply(null,vs.map(function(v){ return v.price; })),variants:vs,type:cat(x)};
}
function load(){
  if(cache) return Promise.resolve(cache);
  if(loading) return loading;
  var all=[];
  function page(n){
    return fetch('/collections/welcome15/products.json?limit=250&page='+n,{headers:{Accept:'application/json'}}).then(function(r){ if(!r.ok) throw new Error(r.status); return r.json(); })
      .then(function(j){ all=all.concat(j.products||[]); return (j.products||[]).length===250&&n<4?page(n+1):all; });
  }
  loading=page(1).then(function(list){
    var styles=[],byKey={};
    list.forEach(function(x){
      if(!x.variants||!x.variants.some(function(v){ return v.available; })) return;
      var p=toP(x); if(p.type==='other') return;
      var key=p.range+'|'+p.name;
      if(!byKey[key]){ byKey[key]={key:key,name:p.name,range:p.range,type:p.type,items:[]}; styles.push(byKey[key]); }
      byKey[key].items.push(p);
    });
    cache=styles; return styles;
  });
  loading.catch(function(){ loading=null; });
  return loading;
}

var css=el('style');
css.textContent='.cbr-tabs{display:flex;gap:0;margin:6px 0 12px;border-bottom:1px solid #e6e1da;}'+
'.cbr-tab{flex:1;min-height:44px;border:0;border-bottom:2px solid transparent;margin-bottom:-1px;background:none;font:inherit;font-size:12px;letter-spacing:.1em;text-transform:uppercase;color:#5f5a54;cursor:pointer;}'+
'.cbr-tab[aria-selected="true"]{border-bottom-color:#111;color:#111;font-weight:600;}'+
'.cbr-all[hidden],.cbr-best[hidden]{display:none;}'+
'.cbr-search{display:block;margin:0 0 10px;}'+
'.cbr-search input{width:100%;box-sizing:border-box;height:44px;padding:0 12px;border:1px solid #d9d3cb;border-radius:6px;font:inherit;font-size:16px;color:#111;background:#fff;}'+
'.cbr-filters{display:flex;gap:6px;overflow-x:auto;padding:0 0 4px;margin:0 0 6px;-webkit-overflow-scrolling:touch;}'+
'.cbr-filter{flex:none;min-height:36px;padding:0 12px;border:1px solid #d9d3cb;border-radius:18px;background:#fff;font:inherit;font-size:12px;color:#111;cursor:pointer;white-space:nowrap;}'+
'.cbr-filter[aria-pressed="true"]{background:#111;color:#fff;border-color:#111;}'+
'.cbr-count{margin:4px 0 2px;font-size:12px;color:#5f5a54;}'+
'.cbr-range{font-size:10px;letter-spacing:.1em;text-transform:uppercase;color:#5f5a54;}'+
'.cbr-colours{display:flex;flex-wrap:wrap;gap:6px;margin-top:2px;}'+
'.cbr-colour{min-height:32px;padding:0 10px;border:1px solid #d9d3cb;border-radius:16px;background:#fff;font:inherit;font-size:11px;letter-spacing:.04em;text-transform:uppercase;color:#111;cursor:pointer;}'+
'.cbr-colour[aria-pressed="true"]{border:1.5px solid #111;font-weight:600;}'+
'.cbr-empty{padding:24px 0;text-align:center;font-size:13px;color:#5f5a54;}';
document.head.appendChild(css);

function enhance(sheet){
  if(sheet.__cbr) return sheet.__cbr; 
  var panel=sheet.querySelector('.cbp-sheet__panel'), note=sheet.querySelector('.cbp-sheet__note'), bestList=sheet.querySelector('[data-cbp-list]');
  if(!panel||!bestList) return null;
  var best=el('div','cbr-best'); note.parentNode.insertBefore(best,note); best.appendChild(note); best.appendChild(bestList);
  var tabs=el('div','cbr-tabs'); tabs.setAttribute('role','tablist');
  var tBest=el('button','cbr-tab','Best matches'), tAll=el('button','cbr-tab','Shop all styles');
  [tBest,tAll].forEach(function(b){ b.type='button'; b.setAttribute('role','tab'); tabs.appendChild(b); });
  best.parentNode.insertBefore(tabs,best);
  var all=el('div','cbr-all'); all.hidden=true; best.parentNode.insertBefore(all,best.nextSibling);
  var lab=el('label','cbr-search'); var sp=el('span',null,'Search styles'); sp.style.cssText='position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);';
  var inp=el('input'); inp.type='search'; inp.placeholder='Search styles or colours'; lab.appendChild(sp); lab.appendChild(inp); all.appendChild(lab);
  var fl=el('div','cbr-filters'); fl.setAttribute('role','group'); fl.setAttribute('aria-label','Filter by type'); all.appendChild(fl);
  var count=el('p','cbr-count'); count.setAttribute('aria-live','polite'); all.appendChild(count);
  var list=el('div','cbr-list'); all.appendChild(list);
  var st={tab:'best',filter:'all',q:'',size:null,exclude:null,data:null,sel:{}};
  FILTERS.forEach(function(f){ var b=el('button','cbr-filter',f[1]); b.type='button'; b.setAttribute('data-f',f[0]); b.addEventListener('click',function(){ st.filter=f[0]; paint(); }); fl.appendChild(b); });
  inp.addEventListener('input',function(){ st.q=inp.value.trim().toUpperCase(); paint(); });
  function setTab(t){
    st.tab=t; tBest.setAttribute('aria-selected',t==='best'); tAll.setAttribute('aria-selected',t==='all');
    best.hidden=t!=='best'; all.hidden=t!=='all';
    if(t==='all'){ if(!st.data){ count.textContent='Loading styles…'; load().then(function(d){ st.data=d; paint(); }).catch(function(){ count.textContent='Couldn’t load styles — please try again.'; }); } else paint(); }
  }
  tBest.addEventListener('click',function(){ setTab('best'); }); tAll.addEventListener('click',function(){ setTab('all'); });

  function row(s){
    var r=el('div','cbp-row'); var p=s.items.find(function(x){ return x.id===st.sel[s.key]; })||s.items[0];
    var im=el('div','cbp-row__img'); if(p.image){ var i=el('img'); i.src=p.image; i.alt=''; i.loading='lazy'; im.appendChild(i); } r.appendChild(im);
    var b=el('div','cbp-row__body');
    if(s.range) b.appendChild(el('span','cbr-range',s.range));
    b.appendChild(el('span','cbp-row__name',s.name+(s.items.length===1&&p.colour?' '+p.colour:'')));
    var pr=el('span','cbp-row__price'); pr.appendChild(el('s',null,fmt(p.price))); pr.appendChild(document.createTextNode(fmt(bundle(p.price)))); b.appendChild(pr);
    if(s.items.length>1){
      var cs=el('div','cbr-colours'); cs.setAttribute('role','group'); cs.setAttribute('aria-label',s.name+' colours');
      s.items.forEach(function(x){ var c=el('button','cbr-colour',x.colour||'Colour'); c.type='button'; c.setAttribute('aria-pressed',x.id===p.id);
        c.addEventListener('click',function(){ st.sel[s.key]=x.id; var n=row(s); r.parentNode.replaceChild(n,r); var f=n.querySelector('.cbr-colour[aria-pressed="true"]'); if(f) f.focus(); }); cs.appendChild(c); });
      b.appendChild(cs);
    }
    var ch=el('div','cbp-row__chips'); ch.setAttribute('role','group'); ch.setAttribute('aria-label',s.name+' sizes');
    p.variants.forEach(function(v){ var c=el('button','cbp-chip',v.size); c.type='button';
      if(st.size&&v.size===st.size) c.classList.add('is-match');
      if(!v.available){ c.disabled=true; c.setAttribute('aria-label',v.size+', sold out'); } else c.setAttribute('aria-label','Choose '+s.name+' '+p.colour+' in size '+v.size);
      c.addEventListener('click',function(){ if(sheet.__cbpPick) sheet.__cbpPick({id:p.id,name:p.name,colour:p.colour,image:p.image,price:p.price,variants:p.variants},v); });
      ch.appendChild(c); });
    b.appendChild(ch); r.appendChild(b); return r;
  }
  function paint(){
    fl.querySelectorAll('.cbr-filter').forEach(function(b){ b.setAttribute('aria-pressed',b.getAttribute('data-f')===st.filter); });
    if(!st.data) return;
    list.innerHTML='';
    var shown=st.data.filter(function(s){
      if(st.filter!=='all'&&s.type!==st.filter) return false;
      if(st.q){ var hay=(s.range+' '+s.name+' '+s.items.map(function(x){ return x.colour; }).join(' ')).toUpperCase(); if(hay.indexOf(st.q)===-1) return false; }
      return true;
    });
    count.textContent=shown.length+' style'+(shown.length===1?'':'s');
    if(!shown.length) list.appendChild(el('p','cbr-empty','No styles match — try another search.'));
    shown.forEach(function(s){ list.appendChild(row(s)); });
  }
  sheet.__cbr={open:function(d){ st.size=d.size||null; if(st.tab==='all') paint(); }, reset:function(){ setTab('best'); }};
  setTab('best');
  return sheet.__cbr;
}
document.addEventListener('cbp:sheet-open',function(e){ var d=e.detail||{}; if(!d.sheet) return; var b=enhance(d.sheet); if(b) b.open(d); });
})();